import { FieldPath, FieldValues, useWatch } from "react-hook-form";
import { useEffect } from "react";
import { RhfAutoComplete } from "./RhfAutoComplete";
import { RhfInputProps } from "../../../../Forms/RhfInputProps";
import { ttProtectionFilterUrls } from "../../../../URL/ApplicationUrls";
import { isArrayUndefinedOrEmpty } from "../../../../Utils/arrays";
import { useFetchIeoPlantsForPlantGsdbs } from "./Hooks/useFetchIeoPlantsForPlantGsdbs";

type Props<
  TFieldValues extends FieldValues = FieldValues,
  TNameToWatch extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  nameToSubscribeTo: TNameToWatch;
};

export const TTProtectionFiltersIeoPlantsMultiSelect = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
>({
  control,
  name,
  nameToSubscribeTo,
}: RhfInputProps<TFieldValues, TName> & Props<TFieldValues, TName>) => {
  const plantGsdbs = useWatch({ control, name: nameToSubscribeTo });

  const { data: ioePlantOptions, refetch } = useFetchIeoPlantsForPlantGsdbs({
    url: ttProtectionFilterUrls.ieoPlants,
    plantGsdbs,
  });

  useEffect(() => {
    refetch();
  }, [plantGsdbs, refetch]);

  return (
    <RhfAutoComplete
      control={control}
      name={name}
      options={isArrayUndefinedOrEmpty(ioePlantOptions) ? [] : ioePlantOptions}
      label="Plant GSDB (IEO)"
    />
  );
};
